export enum FilterType {
    total = 'total',
    today = 'today',
    dateRange = 'date-range'
}

interface DateObject {
    day: number;
    month: number;
    year: number;
}

export interface DateRangeSelect {
    from : DateObject | null;
    to : DateObject | null;
}

export interface OfferAnalyticData {
    completed_count: number;
    pending_count: number;
    scheduled_count: number;
    draft_count: number;
    rejected_count: number;
    completed_offer_amount_chf: string;
    completed_offer_amount_eur: string;
    completed_offer_amount_gbp: string;
    pending_offer_amount_chf: string;
    pending_offer_amount_eur: string;
    pending_offer_amount_gbp: string;
    scheduled_offer_amount_chf: string;
    scheduled_offer_amount_eur: string;
    scheduled_offer_amount_gbp: string;
    rejected_offer_amount_chf: string;
    rejected_offer_amount_eur: string;
    rejected_offer_amount_gbp: string;
    draft_offer_amount_chf: string;
    draft_offer_amount_eur: string;
    draft_offer_amount_gbp: string;
}

export interface AcceptedOfferData {
    accepted_offer_count: number;
    accepted_offer_amount_eur: string;
    accepted_offer_amount_chf: string;
    accepted_offer_amount_gbp: string;
    accepted_offer_amount_sek: string;
    accepted_offer_amount_ron: string;
    accepted_offer_amount_pln: string;
    accepted_offer_amount_czk: string;
    accepted_offer_amount_huf: string;
}

export interface SentOutOfferData {
    pending_offer_count: number;
    pending_offer_amount_eur: string;
    pending_offer_amount_chf: string;
    pending_offer_amount_gbp: string;
    pending_offer_amount_sek: string;
    pending_offer_amount_ron: string;
    pending_offer_amount_pln: string;
    pending_offer_amount_czk: string;
    pending_offer_amount_huf: string;
}


export enum OfferType {
    pending = 'pending',
    scheduled = 'scheduled',
    completed = 'completed',
    draft = 'draft',
    rejected = 'rejected',
    accepted = 'accepted',
    sentOut = 'sentOut'
}

export interface AnalyticCardRef {
    toggleToday: Function;
    resetFilter: Function;
    toggleDateRange: Function;
}

export interface OfferAnalyticCardRef {
    toggleOfferTodayFilter: Function;
    toggleOfferDateRangeFilter: Function;
    toggleOfferReset: Function;
}

export interface OfferAnalyticRef {
    resetFilter: Function;
}

